import React from 'react';
import { useFormikContext } from 'formik';

import { useStyles } from '~/assets/styles';
import CardDialog from '~/components/CardDialog';
import { Text } from '~/components/core';
import { MultiSelectTextFieldFormik } from '~/components/TextFieldFormik';
import { DATA_EXPORT } from '~/Types';

import HourAndEndDateFields from './HourAndEndDateFields';
import { SHARED_EXPORT_TEXTS } from './texts';

interface ScheduleDetailsValues {
  export_days: string[];
  export_hour: string;
  is_end_date?: boolean;
  end_date?: string;
}

const ScheduleDetailsSection: React.FC = () => {
  const { classes } = useStyles();
  const { isSubmitting } = useFormikContext<ScheduleDetailsValues>();

  return (
    <div className="-m-8 p-12">
      <CardDialog containerClassName="bg-slate-200" noCardTitle trackAlt="Schedule Details">
        <Text className="mb-20 font-bold" variant={Text.VARIANTS.LG}>
          {SHARED_EXPORT_TEXTS.SCHEDULE_DETAILS_TITLE}
        </Text>
        <Text variant={Text.VARIANTS.SM}>{SHARED_EXPORT_TEXTS.DAILY_REPEAT_ON}</Text>
        <div className="w-1/2 gap-16">
          <MultiSelectTextFieldFormik
            id="export_days"
            disabled={isSubmitting}
            className={classes.textField}
            fullWidth
            renderOption={(option: string) => DATA_EXPORT.DAYS[option as keyof typeof DATA_EXPORT.DAYS].abbr}
            options={Object.keys(DATA_EXPORT.DAYS).sort()}
            renderValue={() => ''}
            withOptionChips
          />
          <HourAndEndDateFields />
        </div>
      </CardDialog>
    </div>
  );
};

export default ScheduleDetailsSection;
